var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homePage"},[_c('v-container',[_c('div',{staticClass:"controlPanel"},[_vm._v("Betmakers"),_c('br'),_vm._v(" Control Panel")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }